import type { DealPipeline, DealStageDef } from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPost, apiPut } from "./client";

export function listDealPipelines(): Promise<{ pipelines: DealPipeline[] }> {
  return apiGet("/api/deal-pipelines");
}

export function getDefaultDealPipeline(): Promise<{ pipeline: DealPipeline }> {
  return apiGet("/api/deal-pipelines/default");
}

export function createDealPipeline(input: {
  name: string;
  stages?: DealStageDef[];
  isDefault?: boolean;
}): Promise<{ pipeline: DealPipeline }> {
  return apiPost("/api/deal-pipelines", input);
}

export function updateDealPipeline(
  pipelineConfigId: string,
  fields: { name?: string; stages?: DealStageDef[]; isDefault?: boolean },
): Promise<{ pipeline: DealPipeline }> {
  return apiPut(`/api/deal-pipelines/${pipelineConfigId}`, fields);
}

export function deleteDealPipeline(pipelineConfigId: string): Promise<void> {
  return apiDelete(`/api/deal-pipelines/${pipelineConfigId}`);
}
